import { isSensitivePath } from './privacy.js';
import { MEASUREMENT_PATHS, BLOG_POSTS } from './measurementPaths.js';

const ORIGIN = 'https://trinitydentalarts.com';

// Never pass a query string, fragment, form field, quiz answer or patient identity.
export function safePage(value) {
  try {
    const url = new URL(value, ORIGIN);
    if (url.origin !== ORIGIN || isSensitivePath(url.pathname) || !MEASUREMENT_PATHS.has(url.pathname.replace(/\/$/, '') || '/') ||
        !/^\/[a-z0-9/-]*$/i.test(url.pathname)) return '';
    if (url.pathname === '/blog' && url.searchParams.has('post')) {
      const post = url.searchParams.get('post');
      return BLOG_POSTS.has(post) ? ORIGIN + '/blog?post=' + post : '';
    }
    return ORIGIN + url.pathname;
  } catch { return ''; }
}

// The practice owner authorizes default Google measurement on the basis of
// consent obtained directly from visitors. Do not fabricate a stored Accept.
// A recorded decline, privacy signal, unrecognized choice or blocked storage
// always overrides that default. Other advertising SDKs still require opt-in.
export function hasGoogleMeasurementPermission() {
  try {
    if (window.location.origin !== ORIGIN ||
        navigator.globalPrivacyControl === true || navigator.doNotTrack === '1') return false;
    return ['tda_cookie_consent_v2', 'tda_ad_measurement_consent_v2'].every(key => {
      const choice = localStorage.getItem(key);
      return choice === null || choice === 'granted';
    });
  } catch { return false; }
}

// Excluded routes cannot collect or emit events, but visiting one is not a
// withdrawal of permission for the opaque attribution already saved this session.
export function canMeasureGoogle() {
  return hasGoogleMeasurementPermission() &&
    Boolean(safePage(window.location.pathname + (window.location.search || '')));
}

export function googleMeasurementConsent() {
  const status = canMeasureGoogle() ? 'granted' : 'denied';
  return {
    analytics_storage: status,
    ad_storage: status,
    ad_user_data: status,
    ad_personalization: 'denied',
    personalization_storage: 'denied',
  };
}
